/**
 * 買取フローの進捗（1:査定中 2:情報入力 3:発送 4:入金待ち）
 * チャット表示と同じ条件で判定する。
 */
(function (root) {
  function toNumber(value) {
    if (value == null || value === '') return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  /** 最新査定メッセージより後（同時刻含む）に [AGREED] があるか＝本当にボタンで確定したか */
  function hasCustomerAgreedAfterOffer(msgs, offerMsg) {
    if (!offerMsg) return false;
    var offerAt = offerMsg.created_at ? new Date(offerMsg.created_at).getTime() : NaN;
    if (!Number.isFinite(offerAt)) offerAt = 0;
    for (var i = 0; i < (msgs || []).length; i++) {
      var m = msgs[i];
      if (!m || String(m.content || '') !== '[AGREED]') continue;
      var t = m.created_at ? new Date(m.created_at).getTime() : NaN;
      if (!Number.isFinite(t)) t = 0;
      if (t >= offerAt) return true;
    }
    return false;
  }

  function computeBuybackProgress(input) {
    input = input || {};
    const status = String(input.status || 'draft').trim();
    const latestOfferValue = toNumber(input.latestOfferValue);
    const offeredPrice = toNumber(input.offeredPrice);
    const hasShippingMethod = !!input.hasShippingMethod;
    const hasTracking = !!input.hasTracking;
    // 明示フラグ優先（最新査定の後に [AGREED] があるか）
    var agreedOnLatest =
      input.latestOfferAgreedByCustomer === true
        ? true
        : input.latestOfferAgreedByCustomer === false
          ? false
          : latestOfferValue != null &&
            offeredPrice != null &&
            offeredPrice === latestOfferValue &&
            (status === 'agreed' || status === 'form_submitted' || status === 'shipped' || status === 'awaiting_payment' || status === 'shipping_selected');

    // 発送完了（追跡番号登録）以降は入金待ち
    if (status === 'shipped' || status === 'awaiting_payment' || status === 'completed' || hasTracking) {
      return 4;
    }

    // 本申込以降はステータス優先（ただし未確定の新査定がある場合は査定中）
    if ((status === 'form_submitted' || status === 'shipping_selected') && agreedOnLatest) {
      return 3;
    }
    if (status === 'agreed' && agreedOnLatest) {
      return hasShippingMethod ? 3 : 2;
    }

    // 最新の査定額に未同意なら査定中（ボタン再表示）
    if (!agreedOnLatest) {
      return 1;
    }

    if (status === 'form_submitted' || hasShippingMethod) {
      return 3;
    }

    return 2;
  }

  function isBuybackLatestOfferAgreed(input) {
    if (input && input.latestOfferAgreedByCustomer === true) return true;
    if (input && input.latestOfferAgreedByCustomer === false) return false;
    return computeBuybackProgress(input) >= 2;
  }

  function applyBuybackProgressBar(currentStep) {
    const step = Number(currentStep) || 1;
    if (window.__buybackLastProgressStep === step) return;
    window.__buybackLastProgressStep = step;
    const stepsArray = [1, 2, 3, 4];

    stepsArray.forEach(function (n) {
      const stepEl = document.getElementById('step-' + n);
      if (!stepEl) return;
      const circle = stepEl.querySelector('.step-circle');
      const text = stepEl.querySelector('.step-text');
      if (!circle || !text) return;

      if (n < step) {
        circle.style.background = '#07C160';
        circle.style.color = '#fff';
        circle.style.boxShadow = 'none';
        circle.style.outline = 'none';
        circle.classList.remove('step-circle--active');
        circle.textContent = '✓';
        text.style.color = '#166534';
        text.style.fontWeight = 'bold';
        text.classList.remove('step-text--active');
      } else if (n === step) {
        circle.style.background = '#07C160';
        circle.style.color = '#fff';
        circle.style.boxShadow = '0 2px 6px rgba(7, 193, 96, 0.4)';
        circle.style.outline = 'none';
        circle.style.outlineOffset = '0';
        circle.classList.add('step-circle--active');
        circle.textContent = String(n);
        text.style.color = '#166534';
        text.style.fontWeight = 'bold';
        text.classList.add('step-text--active');
      } else {
        circle.style.background = '#e2e8f0';
        circle.style.color = '#94a3b8';
        circle.style.boxShadow = 'none';
        circle.style.outline = 'none';
        circle.classList.remove('step-circle--active');
        circle.textContent = String(n);
        text.style.color = '#94a3b8';
        text.style.fontWeight = 'bold';
        text.classList.remove('step-text--active');
      }
    });

    for (let i = 1; i <= 3; i++) {
      const dots = document.querySelectorAll('#line-' + i + ' .buyback-step-dot');
      dots.forEach(function (dot) {
        // 色だけ変え、寸法は触らない（伸びて黒線になるのを防ぐ）
        dot.style.backgroundColor = step > i ? '#07C160' : '#cbd5e1';
        dot.style.width = '8px';
        dot.style.height = '8px';
        dot.style.minWidth = '8px';
        dot.style.maxWidth = '8px';
        dot.style.minHeight = '8px';
        dot.style.maxHeight = '8px';
        dot.style.borderRadius = '50%';
        dot.style.flex = '0 0 8px';
        dot.style.transform = 'none';
      });
    }

    const bar = document.getElementById('progress-bar-container');
    if (bar) {
      bar.setAttribute('data-current-step', String(step));
      if (bar.classList.contains('is-ready')) {
        for (let s = 1; s <= 3; s++) {
          const line = document.getElementById('line-' + s);
          if (line) line.style.display = 'flex';
        }
      }
    }
    try {
      var customerKey = window.__buybackCustomerKey || '';
      if (!customerKey) {
        try {
          customerKey = localStorage.getItem('guest_buyback_id') || '';
        } catch (eKey) {}
      }
      if (customerKey) {
        sessionStorage.setItem('buyback_progress_step_' + customerKey, String(step));
        localStorage.setItem('buyback_progress_step_' + customerKey, String(step));
      }
    } catch (eStore) {}
  }

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function formatBuybackDateTime(iso) {
    const d = iso ? new Date(iso) : new Date();
    if (isNaN(d.getTime())) return '';
    return (
      d.getFullYear() +
      '/' +
      pad2(d.getMonth() + 1) +
      '/' +
      pad2(d.getDate()) +
      ' ' +
      pad2(d.getHours()) +
      ':' +
      pad2(d.getMinutes())
    );
  }

  function buildPastOffersSummaryHtml(pastOffers, align) {
    const seen = Object.create(null);
    const list = (pastOffers || []).filter(function (m) {
      if (!m) return false;
      const id = m.id != null ? String(m.id) : '';
      if (id) {
        if (seen[id]) return false;
        seen[id] = 1;
      }
      return true;
    });
    if (!list.length) return '';
    const side = align === 'end' ? 'flex-end' : 'flex-start';
    const rows = list
      .slice()
      .reverse()
      .map(function (m) {
        const content = m.content || '';
        const isFinal = content.startsWith('[FINAL_OFFER]:');
        const val = toNumber(String(content).split(':')[1]);
        return (
          '<div style="display:flex;justify-content:space-between;gap:10px;padding:6px 0;border-bottom:1px solid #e2e8f0;font-size:12px;color:#475569;">' +
          '<span>' +
          (isFinal ? '最終査定' : '査定') +
          '</span>' +
          '<span style="font-weight:bold;color:#1e293b;">¥' +
          (val != null ? val.toLocaleString() : '-') +
          '</span>' +
          '<span style="white-space:nowrap;">' +
          formatBuybackDateTime(m.created_at) +
          '</span></div>'
        );
      })
      .join('');

    return (
      '<div data-buyback-past-offers="1" style="display:flex;flex-direction:column;align-items:' +
      side +
      ';margin-bottom:14px;width:100%;">' +
      '<details style="width:85%;max-width:340px;background:#f8fafc;border:1px solid #cbd5e1;border-radius:10px;padding:8px 12px;">' +
      '<summary style="cursor:pointer;font-size:13px;color:#64748b;font-weight:bold;">過去の提示（' +
      list.length +
      '件）</summary>' +
      '<div style="margin-top:4px;">' +
      rows +
      '</div></details></div>'
    );
  }

  root.computeBuybackProgress = computeBuybackProgress;
  root.isBuybackLatestOfferAgreed = isBuybackLatestOfferAgreed;
  root.hasCustomerAgreedAfterOffer = hasCustomerAgreedAfterOffer;
  root.applyBuybackProgressBar = applyBuybackProgressBar;
  root.buildPastOffersSummaryHtml = buildPastOffersSummaryHtml;

  function buybackNodeCreatedAtMs(el) {
    if (!el) return NaN;
    backfillBuybackCreatedAtFromLabel(el);
    var ca = el.getAttribute && el.getAttribute('data-created-at');
    if (!ca) return NaN;
    var t = new Date(ca).getTime();
    return Number.isFinite(t) ? t : NaN;
  }

  function buybackParseTimeLabel(el) {
    if (!el || el.nodeType !== 1) return '';
    var header = el.children && el.children[0];
    if (!header) return '';
    var spans = header.querySelectorAll ? header.querySelectorAll('span') : [];
    for (var si = 0; si < spans.length; si++) {
      var tx = String(spans[si].textContent || '').trim();
      if (/^\d{1,2}:\d{2}$/.test(tx)) return tx;
    }
    var raw = String(header.textContent || '').trim();
    var m = raw.match(/(\d{1,2}:\d{2})\s*$/);
    return m ? m[1] : '';
  }

  /** HH:MM だけから補完するとき、今日付けにすると査定カードが歓迎文より前へ飛ぶ。直前ノード／日付区切り／案件作成日を使う。 */
  function backfillBuybackCreatedAtFromLabel(el) {
    if (!el || el.nodeType !== 1 || el.getAttribute('data-created-at')) return;
    if (el.getAttribute('data-buyback-date-sep') === '1') return;
    var timeStr = buybackParseTimeLabel(el);
    if (!timeStr) return;
    var parts = timeStr.split(':');
    var base = null;
    var prev = el.previousElementSibling;
    while (prev) {
      var ca = prev.getAttribute('data-created-at');
      if (ca) {
        var pdt = new Date(ca);
        if (Number.isFinite(pdt.getTime())) {
          base = pdt;
          break;
        }
      }
      if (prev.getAttribute('data-buyback-date-sep') === '1') {
        var sepTx = String(prev.textContent || '').trim();
        var dm = sepTx.match(/(\d{4})\s*\/\s*(\d{1,2})\s*\/\s*(\d{1,2})/);
        if (dm) {
          base = new Date(Number(dm[1]), Number(dm[2]) - 1, Number(dm[3]), 0, 0, 0, 0);
          break;
        }
      }
      prev = prev.previousElementSibling;
    }
    if (!base) {
      var root = el.parentElement;
      var reqIso = root && root.getAttribute('data-buyback-req-created');
      if (reqIso) {
        var rdt = new Date(reqIso);
        if (Number.isFinite(rdt.getTime())) base = rdt;
      }
    }
    // 今日付けフォールバックはしない（買取ボタンが先頭へ飛ぶ原因）
    if (!base || !Number.isFinite(base.getTime())) return;
    var d = new Date(base.getTime());
    d.setSeconds(0, 0);
    d.setMilliseconds(0);
    d.setHours(Number(parts[0]) || 0, Number(parts[1]) || 0, 0, 0);
    el.setAttribute('data-created-at', d.toISOString());
  }

  function buybackIsOfferWrap(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.getAttribute('data-buyback-offer-id')) return true;
    if (el.getAttribute('data-admin-offer-card') === '1') return true;
    return !!(el.querySelector && el.querySelector('.buyback-offer-card'));
  }

  function buybackIsDateSepNode(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.getAttribute('data-buyback-date-sep') === '1') return true;
    var t = String(el.textContent || '').replace(/\s+/g, '');
    return /^\d{4}\/\d{1,2}\/\d{1,2}$/.test(t);
  }

  /** コメント・フローUI・査定カードすべて created_at の時系列位置へ。末尾強制はしない。 */
  root.insertBuybackNodeByCreatedAt = function (chatBox, node, createdAtIso) {
    if (!chatBox || !node) return;
    if (createdAtIso) node.setAttribute('data-created-at', String(createdAtIso));
    else backfillBuybackCreatedAtFromLabel(node);
    if (node.parentNode) node.parentNode.removeChild(node);
    var past = chatBox.querySelector('[data-buyback-past-offers="1"]');
    var t = buybackNodeCreatedAtMs(node);
    var anchor = null;
    var children = Array.prototype.slice.call(chatBox.children);
    children.forEach(backfillBuybackCreatedAtFromLabel);
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (!c || c === node) continue;
      if (c.getAttribute('data-buyback-past-offers') === '1') continue;
      if (buybackIsDateSepNode(c)) continue;
      if (c.getAttribute('data-buyback-welcome') === '1') continue;
      var ct = buybackNodeCreatedAtMs(c);
      if (Number.isFinite(t) && Number.isFinite(ct) && ct > t) {
        if (buybackIsOfferWrap(c) && past && past.parentNode === chatBox) anchor = past;
        else anchor = c;
        break;
      }
    }
    if (anchor) chatBox.insertBefore(node, anchor);
    else chatBox.appendChild(node);
  };

  root.removeBuybackChatBoxChildContaining = function (el) {
    var chatBox = document.getElementById('chat-box');
    if (!chatBox || !el || !chatBox.contains(el)) return;
    var node = el;
    while (node.parentElement && node.parentElement !== chatBox) node = node.parentElement;
    if (node.parentElement === chatBox) node.remove();
    else el.remove();
  };

  root.pruneEmptyBuybackPhaseShells = function (chatBox) {
    chatBox = chatBox || document.getElementById('chat-box');
    if (!chatBox) return;
    Array.prototype.slice.call(chatBox.children).forEach(function (el) {
      if (!el || el.nodeType !== 1) return;
      if (el.getAttribute('data-buyback-msg-id')) return;
      if (el.getAttribute('data-buyback-offer-id')) return;
      if (el.getAttribute('data-buyback-past-offers')) return;
      if (el.getAttribute('data-buyback-welcome')) return;
      if (el.getAttribute('data-buyback-app-form-wrap')) return;
      if (el.getAttribute('data-buyback-form-guide')) return;
      if (
        el.querySelector &&
        el.querySelector('.buyback-offer-card, #application-form, [id^="buyback-step-"], img, video, button, input, textarea, select, form')
      ) {
        return;
      }
      var text = String(el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || /^(店舗|申込フォーム|選択フェーズ)(\s*\d{1,2}:\d{2})?$/.test(text)) el.remove();
    });
  };
  root.dedupeBuybackOfferMessages = function (list) {
    var seen = Object.create(null);
    var out = [];
    (list || []).forEach(function (m) {
      if (!m) return;
      var id = m.id != null ? String(m.id) : '';
      if (id) {
        if (seen[id]) return;
        seen[id] = 1;
      }
      out.push(m);
    });
    return out;
  };

  root.removeBuybackPastOfferSummaries = function (rootEl) {
    var chatBox = rootEl || document.getElementById('chat-box');
    if (!chatBox) return;
    chatBox.querySelectorAll('[data-buyback-past-offers="1"]').forEach(function (el) {
      el.remove();
    });
    Array.prototype.slice.call(chatBox.querySelectorAll('details')).forEach(function (d) {
      var sum = d.querySelector('summary');
      if (!sum || String(sum.textContent || '').indexOf('過去の提示') === -1) return;
      var wrap = d.parentElement;
      if (wrap && wrap !== chatBox && wrap.querySelector && wrap.querySelector('details') === d) wrap.remove();
      else d.remove();
    });
  };

  root.ensureBuybackPastOffersSummary = function (pastOffers, beforeNode, appendHtmlFn) {
    var chatBox = document.getElementById('chat-box');
    if (!chatBox) return;
    root.removeBuybackPastOfferSummaries(chatBox);
    if (!pastOffers || !pastOffers.length) return;
    var html = root.buildPastOffersSummaryHtml(pastOffers, 'start');
    if (!html) return;
    var anchor = beforeNode;
    if (!anchor || !chatBox.contains(anchor)) {
      anchor =
        chatBox.querySelector('[data-buyback-offer-id]') ||
        (function () {
          var c = chatBox.querySelector('.buyback-offer-card');
          return c && c.parentElement !== chatBox ? c.parentElement : c;
        })();
    }
    if (anchor && chatBox.contains(anchor)) {
      anchor.insertAdjacentHTML('beforebegin', html);
    } else if (typeof appendHtmlFn === 'function') {
      appendHtmlFn(html);
    } else {
      chatBox.insertAdjacentHTML('beforeend', html);
    }
  };

  function buybackIsDateSepNode(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.getAttribute('data-buyback-date-sep') === '1') return true;
    var t = String(el.textContent || '').replace(/\s+/g, '');
    return /^\d{4}\/\d{1,2}\/\d{1,2}$/.test(t);
  }

  root.buybackBeginFilePickerGuard = function () {
    window.__buybackFilePickerGuardUntil = Date.now() + 180000;
    window.__buybackSuppressMessageReload = true;
  };

  root.buybackClearFilePickerGuard = function () {
    window.__buybackFilePickerGuardUntil = 0;
  };

  root.buybackShouldSkipChatReload = function () {
    if (window.__buybackSuppressMessageReload) return true;
    if (window.__buybackMediaUploadLock) return true;
    if (window.__buybackFilePickerGuardUntil && Date.now() < window.__buybackFilePickerGuardUntil) return true;
    return false;
  };

  function buybackTrackingDraftKey(requestId) {
    var id = requestId || window.__buybackActiveRequestId || '';
    return id ? 'buyback_tracking_draft_' + id : '';
  }

  root.saveBuybackTrackingDraft = function () {
    var key = buybackTrackingDraftKey();
    if (!key) return;
    var el = document.getElementById('customer-tracking-number');
    if (!el) return;
    var digits = String(el.value || '').replace(/[^\d]/g, '');
    try {
      if (digits) {
        localStorage.setItem(key, digits);
        sessionStorage.setItem(key, digits);
      } else {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      }
    } catch (e) {}
  };

  root.readBuybackTrackingDraft = function () {
    var key = buybackTrackingDraftKey();
    if (!key) return '';
    try {
      return String(sessionStorage.getItem(key) || localStorage.getItem(key) || '').replace(/[^\d]/g, '');
    } catch (e) {
      return '';
    }
  };

  root.restoreBuybackTrackingDraft = function () {
    var el = document.getElementById('customer-tracking-number');
    if (!el) return;
    var current = String(el.value || '').replace(/[^\d]/g, '');
    if (current) {
      root.saveBuybackTrackingDraft();
      if (typeof window.syncShippingCompleteButton === 'function') window.syncShippingCompleteButton();
      return;
    }
    var draft = root.readBuybackTrackingDraft();
    if (!draft) return;
    el.value = draft;
    if (typeof window.syncShippingCompleteButton === 'function') window.syncShippingCompleteButton();
  };

  root.clearBuybackTrackingDraft = function () {
    var key = buybackTrackingDraftKey();
    if (!key) return;
    try {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (e) {}
  };

  window.saveBuybackTrackingDraft = root.saveBuybackTrackingDraft;
  window.readBuybackTrackingDraft = root.readBuybackTrackingDraft;
  window.restoreBuybackTrackingDraft = root.restoreBuybackTrackingDraft;
  window.clearBuybackTrackingDraft = root.clearBuybackTrackingDraft;

  root.blurBuybackActionInputs = function () {
    ['customer-message-input', 'customer-media-input'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) {
        try { el.blur(); } catch (eB) {}
      }
    });
    var ae = document.activeElement;
    if (
      ae &&
      typeof ae.blur === 'function' &&
      ae !== document.body &&
      ae.closest &&
      ae.closest('#chat-input-area, .buyback-chat-input')
    ) {
      try { ae.blur(); } catch (eB2) {}
    }
  };
  window.blurBuybackActionInputs = root.blurBuybackActionInputs;

  root.buybackOnVisibleAfterFilePicker = function () {
    if (!window.__buybackFilePickerGuardUntil || window.__buybackMediaUploadLock) return;
    setTimeout(function () {
      if (window.__buybackMediaUploadLock) return;
      var inp = document.getElementById('customer-media-input');
      if (inp && inp.files && inp.files.length) return;
      if (!window.__buybackFilePickerGuardUntil) return;
      root.buybackClearFilePickerGuard();
      window.__buybackSuppressMessageReload = false;
    }, 1500);
  };

  function bindBuybackMediaPickerGuard() {
    var inp = document.getElementById('customer-media-input');
    if (inp && !inp.__pickerGuardBound) {
      inp.__pickerGuardBound = true;
      function arm() { root.buybackBeginFilePickerGuard(); }
      inp.addEventListener('click', arm);
      inp.addEventListener('change', function () {
        if (!inp.files || !inp.files.length) {
          root.buybackClearFilePickerGuard();
          window.__buybackSuppressMessageReload = false;
        }
      });
      var lab = document.querySelector('label[for="customer-media-input"]');
      if (lab) lab.addEventListener('click', arm);
    }
  }

  function bindBuybackIdCardPickerGuard() {
    function armId() { root.buybackBeginFilePickerGuard(); }
    function onIdChange(ev) {
      var t = ev && ev.target;
      if (t && t.files && t.files.length) return;
      root.buybackClearFilePickerGuard();
      window.__buybackSuppressMessageReload = false;
    }
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t) return;
      if (t.id && String(t.id).indexOf('id-card-input-') === 0) armId();
      if (t.closest && t.closest('[for^="id-card-input-"], label[id^="id-upload-"], .buyback-id-upload, #application-form label')) {
        var lab = t.closest('label');
        if (lab && lab.getAttribute('for') && String(lab.getAttribute('for')).indexOf('id-card-input-') === 0) armId();
      }
    }, true);
    document.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t && t.id && String(t.id).indexOf('id-card-input-') === 0) onIdChange(ev);
    }, true);
  }

  function bindBuybackPickerGuards() {
    bindBuybackMediaPickerGuard();
    if (!window.__buybackIdPickerGuardBound) {
      window.__buybackIdPickerGuardBound = true;
      bindBuybackIdCardPickerGuard();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindBuybackPickerGuards);
  } else {
    bindBuybackPickerGuards();
  }

  function buybackIsWelcomeMsgNode(el) {
    if (!el || el.nodeType !== 1) return false;
    if (buybackIsDateSepNode(el)) return false;
    if (el.getAttribute('data-buyback-welcome') === '1') return true;
    return String(el.textContent || '').indexOf('フィギュアの査定はお任せください') !== -1;
  }

  /** 過去の提示＋査定カードをセットで created_at 位置へ。歓迎文より前には絶対置かない。 */
  root.placeBuybackOfferAtLatestPosition = function (chatBox, offerNode) {
    if (!chatBox || !offerNode) return;
    var pastEl = chatBox.querySelector('[data-buyback-past-offers="1"]');

    // すでに歓迎文の下にある査定カードは、スマホ復帰時の再同期で動かさない
    if (offerNode.parentNode === chatBox && offerNode.getAttribute('data-created-at')) {
      var childrenNow = Array.prototype.slice.call(chatBox.children);
      var offerIdx = childrenNow.indexOf(offerNode);
      var welcomeIdx = -1;
      for (var wi = 0; wi < childrenNow.length; wi++) {
        if (buybackIsWelcomeMsgNode(childrenNow[wi])) welcomeIdx = wi;
      }
      if (welcomeIdx >= 0 && offerIdx > welcomeIdx) {
        if (pastEl && pastEl.parentNode === chatBox && pastEl.nextSibling !== offerNode) {
          chatBox.insertBefore(pastEl, offerNode);
        }
        return;
      }
    }

    if (pastEl && pastEl.parentNode) pastEl.parentNode.removeChild(pastEl);
    if (offerNode.parentNode) offerNode.parentNode.removeChild(offerNode);

    Array.prototype.forEach.call(chatBox.children, backfillBuybackCreatedAtFromLabel);
    var t = buybackNodeCreatedAtMs(offerNode);
    var anchor = null;
    var children = Array.prototype.slice.call(chatBox.children);
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (!c || c === offerNode || c === pastEl) continue;
      if (buybackIsDateSepNode(c)) continue;
      if (buybackIsWelcomeMsgNode(c)) continue;
      var ct = buybackNodeCreatedAtMs(c);
      if (Number.isFinite(t) && Number.isFinite(ct) && ct > t) {
        anchor = c;
        break;
      }
    }
    if (anchor) chatBox.insertBefore(offerNode, anchor);
    else chatBox.appendChild(offerNode);
    if (pastEl) chatBox.insertBefore(pastEl, offerNode);

    // 歓迎文より前なら歓迎の直後へ押し戻す
    var welcomeMsg = null;
    Array.prototype.forEach.call(chatBox.children, function (el) {
      if (buybackIsWelcomeMsgNode(el)) welcomeMsg = el;
    });
    if (welcomeMsg && offerNode.compareDocumentPosition(welcomeMsg) & Node.DOCUMENT_POSITION_FOLLOWING) {
      if (welcomeMsg.nextSibling) chatBox.insertBefore(offerNode, welcomeMsg.nextSibling);
      else chatBox.appendChild(offerNode);
      if (pastEl) chatBox.insertBefore(pastEl, offerNode);
    }
    root.pruneEmptyBuybackPhaseShells(chatBox);
  };

  /** 職業・身分証種類だけ innerHTML キャッシュ向けに selected を刻む */
  root.stampBuybackSelectDraftIntoDom = function () {
    ['occupation', 'id-method'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || el.tagName !== 'SELECT') return;
      var val = el.value;
      for (var j = 0; j < el.options.length; j++) {
        var opt = el.options[j];
        if (opt.value === val) opt.setAttribute('selected', 'selected');
        else opt.removeAttribute('selected');
      }
    });
  };

  root.preserveBuybackSelectDraftValues = function (requestId, occVal, idMethodVal) {
    var out = { occupation: occVal || '', id_method: idMethodVal || '' };
    if (!requestId) return out;
    try {
      var raw = localStorage.getItem('buyback_draft_' + requestId);
      if (!raw) return out;
      var prev = JSON.parse(raw) || {};
      if (!out.occupation && prev.occupation) out.occupation = prev.occupation;
      if (!out.id_method && prev.id_method) out.id_method = prev.id_method;
    } catch (e) {}
    return out;
  };

  root.fillBuybackDraftTextFields = function (requestId, data) {
    data = data || {};
    var draft = {};
    try {
      var raw = localStorage.getItem('buyback_draft_' + (requestId || ''));
      if (raw) draft = JSON.parse(raw) || {};
    } catch (e) {}
    function fillIfEmpty(id, val) {
      var el = document.getElementById(id);
      if (!el || String(el.value || '').trim()) return;
      if (val == null || val === '') return;
      el.value = String(val);
    }
    fillIfEmpty('full-name', draft.full_name || data.full_name);
    fillIfEmpty('full-name-kana', draft.full_name_kana || data.full_name_kana);
    fillIfEmpty('postal-code', draft.postal_code || data.postal_code);
    fillIfEmpty('address', draft.address || data.address);
    fillIfEmpty('birth-date', draft.birth_date || data.birth_date);
    fillIfEmpty('bank-code', draft.bank_code || data.bank_code);
    fillIfEmpty('branch-code', draft.branch_code || data.branch_code);
    fillIfEmpty('account-number', draft.account_number || data.account_number);
    fillIfEmpty('account-holder-name', draft.account_holder_name || data.account_holder_name);
    var acct = document.getElementById('account-type');
    if (acct && !acct.value) acct.value = draft.account_type || data.account_type || 'futsu';
    return draft;
  };

  /** 職業・身分証種類を下書き／台帳から復元（空のキャッシュ selected を上書き） */
  root.restoreBuybackSelectDraftFields = function (requestId) {
    var draft = {};
    try {
      var id = requestId || window.__buybackActiveRequestId || '';
      if (!id) return;
      var raw = localStorage.getItem('buyback_draft_' + id);
      if (raw) draft = JSON.parse(raw) || {};
    } catch (e) {}
    var ledger = window.__ledgerCustomer || {};
    function restore(selectId, val) {
      if (!val) return;
      var el = document.getElementById(selectId);
      if (!el) return;
      for (var i = 0; i < el.options.length; i++) {
        if (el.options[i].value === val) {
          el.value = val;
          return;
        }
      }
    }
    restore('occupation', draft.occupation || ledger.occupation || '');
    restore('id-method', draft.id_method || ledger.id_method || '');
  };
  /**
   * 客側に案件キャンセル権限は無い。
   * 進行中があれば再接続。無ければ既存draftを再利用（status更新しない）。
   */
  root.buybackResolveFreshStartTarget = async function (db, customerId, hasDraftContentFn) {
    if (!db || !customerId) return { type: 'fresh', keepDraftId: null };
    try {
      var activeRes = await db
        .from('buyback_requests')
        .select('id,status')
        .eq('shopify_customer_id', customerId)
        .in('status', ['offered', 'agreed', 'form_submitted', 'shipped', 'awaiting_payment', 'shipping_selected'])
        .order('updated_at', { ascending: false })
        .limit(1);
      var activeKeep = activeRes && activeRes.data;
      if (activeKeep && activeKeep[0] && activeKeep[0].id) {
        return { type: 'reconnect', id: activeKeep[0].id, status: activeKeep[0].status || 'draft' };
      }
    } catch (e1) {}
    var keepDraftId = null;
    try {
      var draftRes = await db
        .from('buyback_requests')
        .select('id,updated_at')
        .eq('shopify_customer_id', customerId)
        .eq('status', 'draft')
        .order('updated_at', { ascending: false });
      var opens = (draftRes && draftRes.data) || [];
      for (var i = 0; i < opens.length; i++) {
        var row = opens[i];
        var keep = false;
        try {
          keep = typeof hasDraftContentFn === 'function' && (await hasDraftContentFn(row.id));
        } catch (e2) {}
        if (keep) {
          keepDraftId = row.id;
          break;
        }
        if (!keepDraftId) keepDraftId = row.id;
      }
    } catch (e3) {}
    return { type: 'fresh', keepDraftId: keepDraftId };
  };
  /**
   * 客側に買取リセット権限は無い。進行中案件への再接続だけ行う。
   * 新規draft作成・キャッシュ破棄・歓迎画面への白紙化はしない。
   */
  root.buybackCustomerResumeActiveOnly = async function (db, customerId) {
    if (!db || !customerId) return null;
    try {
      var activeRes = await db
        .from('buyback_requests')
        .select('id,status')
        .eq('shopify_customer_id', customerId)
        .in('status', ['offered', 'agreed', 'form_submitted', 'shipped', 'awaiting_payment', 'shipping_selected'])
        .order('updated_at', { ascending: false })
        .limit(1);
      var active = activeRes && activeRes.data && activeRes.data[0];
      if (active && active.id) return active;
      var draftRes = await db
        .from('buyback_requests')
        .select('id,status')
        .eq('shopify_customer_id', customerId)
        .eq('status', 'draft')
        .order('updated_at', { ascending: false })
        .limit(1);
      var draft = draftRes && draftRes.data && draftRes.data[0];
      return draft && draft.id ? draft : null;
    } catch (e) {
      return null;
    }
  };
  /**
   * 店側が cancelled/completed にしたときだけ客側を次査定へ進める準備。
   * 客の通知開封などでは呼ばない。進行中案件があれば再接続のみ。
   */
  root.buybackPrepareFreshAfterStoreClose = async function (db, customerId, currentRequestId, hasDraftContentFn) {
    if (!db || !customerId) return { action: 'noop' };
    try {
      if (currentRequestId) {
        var curRes = await db.from('buyback_requests').select('status').eq('id', currentRequestId).single();
        var st = curRes && curRes.data && curRes.data.status;
        if (st !== 'cancelled' && st !== 'completed') {
          var still = await root.buybackCustomerResumeActiveOnly(db, customerId);
          if (still && still.id) return { action: 'reconnect', id: still.id, status: still.status || 'draft' };
          return { action: 'noop' };
        }
      } else {
        return { action: 'noop' };
      }
      var other = await root.buybackCustomerResumeActiveOnly(db, customerId);
      if (other && other.id && String(other.id) !== String(currentRequestId)) {
        return { action: 'reconnect', id: other.id, status: other.status || 'draft' };
      }
      var target = { type: 'fresh', keepDraftId: null };
      if (typeof root.buybackResolveFreshStartTarget === 'function') {
        target = (await root.buybackResolveFreshStartTarget(db, customerId, hasDraftContentFn)) || target;
      }
      if (target.type === 'reconnect' && target.id && String(target.id) !== String(currentRequestId)) {
        return { action: 'reconnect', id: target.id, status: target.status || 'draft' };
      }
      return { action: 'fresh', keepDraftId: target.keepDraftId || null };
    } catch (e) {
      return { action: 'noop' };
    }
  };
})(window);
